<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21.2013 0.0231988L8.67947 3.15365C8.34066 3.2384 8.08693 3.55607 8.08693 3.91284C8.08693 11.5174 8.08693 10.3811 8.08693 18.3711C7.43204 17.9762 6.62049 17.7391 5.7391 17.7391C3.5813 17.7391 1.82602 19.1433 1.82602 20.8695C1.82602 22.5958 3.5813 24 5.7391 24C7.89689 24 9.65218 22.5958 9.65218 20.8695V9.21961L20.6088 6.48046V13.6754C19.9539 13.2805 19.1423 13.0434 18.261 13.0434C16.1032 13.0434 14.3479 14.4476 14.3479 16.1738C14.3479 17.9001 16.1032 19.3043 18.261 19.3043C20.4188 19.3043 22.174 17.9001 22.174 16.1738C22.174 10.8296 22.174 6.12975 22.174 0.782386C22.174 0.282089 21.6996 -0.0997075 21.2013 0.0231988Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMusic',
  props: {
    fill: {
      type: String,
      default: 'red'
    }
  }
}
</script>
